/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import {
  Ingestion,
  IngestionFromJSON,
  IngestionFromJSONTyped,
  IngestionToJSON,
} from "./Ingestion";

/**
 *
 * @export
 * @interface IngestionListResponse
 */
export interface IngestionListResponse {
  /**
   *
   * @type {number}
   * @memberof IngestionListResponse
   */
  offset: number;
  /**
   *
   * @type {number}
   * @memberof IngestionListResponse
   */
  limit: number;
  /**
   *
   * @type {string}
   * @memberof IngestionListResponse
   */
  order: string;
  /**
   *
   * @type {string}
   * @memberof IngestionListResponse
   */
  sort: string;
  /**
   *
   * @type {number}
   * @memberof IngestionListResponse
   */
  count: number;
  /**
   *
   * @type {Array<Ingestion>}
   * @memberof IngestionListResponse
   */
  data: Array<Ingestion>;
}

export function IngestionListResponseFromJSON(
  json: any
): IngestionListResponse {
  return IngestionListResponseFromJSONTyped(json, false);
}

export function IngestionListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): IngestionListResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(IngestionFromJSON),
  };
}

export function IngestionListResponseToJSON(
  value?: IngestionListResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(IngestionToJSON),
  };
}
